import { ThemeProvider } from '@mui/material/styles';
import { Outlet } from "react-router-dom";
import { ResponsiveFontTheme } from './utils/theme';
import './App.css';
import Header from './components/Header';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ConnectionsHome from './screens/ConnectionsHome';
import AddConnections from './screens/AddConnections';
import MyConnections from './screens/MyConnections';
import SentRequests from './screens/SentRequests';
import ReceivedRequests from './screens/ReceivedRequests';
import UnauthorisedPage from "./screens/UnauthorisedPage";
import PageNotFound from './screens/PageNotFound';
import { useSelector } from 'react-redux';
import FloatingIconWrapper from "@BNIGlobal/floating-icon";
import { useTheme } from "@mui/material";
import { CHATBOT_COOKIE_KEY, getCookie, isFieldNotEmpty } from './utils/config';

const AppLayout = () => {
  const theme = useTheme();
  const chatbotDetails = getCookie(CHATBOT_COOKIE_KEY);
  const chatbotUrl = isFieldNotEmpty(chatbotDetails) ? chatbotDetails : "";
  return (
    <>
      <Header />
      <FloatingIconWrapper
        iconClickLink={chatbotUrl}
        dir={theme.direction}
        showIcon={isFieldNotEmpty(chatbotUrl)}
      >
        <Outlet />
      </FloatingIconWrapper>
    </>
  );
};


function App() { 
  const languageOrientation = useSelector((state) => state.profileDetails.languageOrientation);
  const theme = ResponsiveFontTheme(languageOrientation);
  document.body.dir = languageOrientation;

    const homeRouter = createBrowserRouter([
      { path:"web/",
        element: <AppLayout />,
        children: [
          {
            path: "connections",
            element: <ConnectionsHome />,
          },
          {
            path: "connections/add-connections",
            element: <AddConnections />,
          },
          {
            path: "connections/my-connections",
            element: <MyConnections />
          },
          {
            path: "connections/sent-requests",
            element: <SentRequests />
          },
          {
            path: "connections/received-requests",
            element: <ReceivedRequests />
          },
          {
            path: "connections/unauthorised",
            element: <UnauthorisedPage />,
          }
        ], 
        errorElement:<PageNotFound/> 
      }
     
    ]);

   
  return (  
    
      <ThemeProvider theme={theme}>
        <div className="App">
              <RouterProvider router={homeRouter} /> 
        </div>
      </ThemeProvider>
    
  );
}

export default App;
